<template>
  <div class="route-marker">
    <app-icon :icon="templateIcon"/>

    <div class="route-marker__count">
      {{ coordinatesCount }}
    </div>

    <div class="route-marker__coordinate route-marker__coordinate-from">
      <img v-if="startCoordinateTitlePictureUrl"
           :src="startCoordinateTitlePictureUrl"
           alt="start coordinate title picture"
           class="route-marker__coordinate-picture"
      >
    </div>

    <div class="route-marker__coordinate route-marker__coordinate-to">
      <img v-if="finishCoordinateTitlePictureUrl"
           :src="finishCoordinateTitlePictureUrl"
           alt="finish coordinate title picture"
           class="route-marker__coordinate-picture"
      >
    </div>
  </div>
</template>

<script>
import Route from "@/models/Route";
import { mapGetters } from "vuex";

export default {
  name: "RouteMarker",
  props: {
    route: {
      type: Route,
      required: true
    }
  },
  computed: {
    ...mapGetters('Coordinates', ['getCoordinateById']),

    coordinates() {
      return this.route.coordinates
    },
    coordinatesCount() {
      return this.coordinates?.length || 0
    },
    templateIcon() {
      return this.route.isCustom || this.route.isNew || this.route.isEditing
        ? 'route-marker-template-editable'
        : 'route-marker-template'
    },
    startCoordinate() {
      return this.coordinates.at(0)
    },
    startCoordinateTitlePictureUrl() {
      return this.startCoordinate?.coverImage.titlePicture.srcXs || null
    },
    finishCoordinate() {
      return this.coordinates.at(-1)
    },
    finishCoordinateTitlePictureUrl() {
      return this.finishCoordinate?.coverImage.titlePicture.srcXs || null
    }
  }
}
</script>

<style lang="scss">
.route-marker {
  position: relative;
  width: 76px;
  height: 76px;

  &__count {
    position: absolute;
    top: 0;
    right: 0;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 500;
    color: $app-block-color;
    border: 2px solid $app-block-color;
    border-radius: 50%;
    background-color: $app-primary-color;
  }

  &__coordinate {
    position: absolute;
    width: 32px;
    height: 32px;
    border: 4px solid $app-primary-color;
    border-radius: 50%;
    background-color: $app-block-color;
    overflow: hidden;
  }

  &__coordinate-picture {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__coordinate-from {
    left: 1px;
    top: 6px;
  }
  &__coordinate-to {
    right: 0;
    bottom: 5px;
  }

}
</style>